module.exports = __webpack_public_path__ + "static/media/Sept12-17.a6ef8ed3.png";